import { render } from "./FinishVerificationView.vue?vue&type=template&id=fc57c296&scoped=true"
import script from "./FinishVerificationView.vue?vue&type=script&lang=js"
export * from "./FinishVerificationView.vue?vue&type=script&lang=js"

import "./FinishVerificationView.vue?vue&type=style&index=0&id=fc57c296&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc57c296"]])

export default __exports__